import { Button, ListGroup, Modal } from 'react-bootstrap';
import React, { useCallback, useState } from 'react';
import {
    useGroupAncestorsQuery,
    useGroupQuery,
    useMeQuery,
    useUpdateUserGroupMutation,
    useUserQuery,
} from '../../../generated/graphql';

import { useField } from 'formik';

interface GroupSelectorProps {
    isStudent: boolean;
    name?: string;
}

export const GroupSelector: React.FC<GroupSelectorProps> = ({ isStudent, name = 'group' }) => {
    const me = useMeQuery();
    const userId = me.data?.me?.id;
    const user = useUserQuery({ variables: { id: userId || '' }, skip: !userId });
    const [updateUserGroup] = useUpdateUserGroupMutation();
    const [showModal, setShowModal] = useState(false);
    const [currentGroup, setCurrentGroup] = useState(1);

    const { data } = useGroupQuery({ variables: { id: currentGroup }, skip: !showModal });

    const openModal = useCallback(() => {
        setShowModal(true);
    }, []);

    const hideModal = useCallback(() => {
        setShowModal(false);
        setCurrentGroup(1);
    }, [setCurrentGroup]);

    const onGroupClick = useCallback(
        async (group: any) => {
            if (group.isFinal) {
                await updateUserGroup({ variables: { id: group.id } });
                await new Promise((resolve) => setTimeout(resolve, 1000));
                user.refetch();
                hideModal();
                return;
            }
            setCurrentGroup(group.id);
        },
        [hideModal, updateUserGroup, user],
    );

    const group = data?.group;

    const selectedGroup = user.data?.user?.group.name;

    const isModerator = me.data?.me?.moderator;
    return (
        <div>
            <div>
                {isStudent ? 'Ваша група:' : 'Ваша кафедра:'} {selectedGroup}
                <Button onClick={openModal} style={{ marginLeft: 10 }}>
                    {selectedGroup ? 'Змінити' : 'Вибрати'}
                </Button>
            </div>
            <Modal show={showModal} onHide={hideModal} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{isStudent ? 'Виберіть вашу групу' : 'Виберіть вашу кафедру'}</Modal.Title>
                </Modal.Header>
                {isModerator ? (
                    <>
                        <span style={{ margin: 15 }}>
                            Модератор не може самостійно змінити свою кафедру. <br /> Якщо ваша кафедра не відповідає
                            дійсності - напишіть{' '}
                            <a href="mailto:Tabakharniuk_Vi@ifnmu.edu.ua">Tabakharniuk_Vi@ifnmu.edu.ua</a> <br />
                        </span>
                    </>
                ) : (
                    group?.children?.map((childrenItem) => {
                        return (
                            <ListGroup.Item
                                key={childrenItem.id}
                                onClick={() => onGroupClick(childrenItem)}
                                style={{ cursor: 'pointer' }}
                            >
                                {childrenItem.name}
                            </ListGroup.Item>
                        );
                    })
                )}
            </Modal>
        </div>
    );
};
